<template>
    <list-search v-bind="{ showsSearch, loading }" hide-actions>
        <v-row class="ma-n1">
            <v-col class="pa-1" cols="12">
                <search-duration v-model="query['searchDateValue']" @input="push" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import { initDuration } from "@/components/console/dumb/list/search-duration";
import ListSearch from "@/components/console/dumb/list/list-search.vue";
import SearchDuration from "@/components/console/dumb/list/search-duration.vue";

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["searchDateValue"]: [...(query["searchDateValue"] ?? initDuration())],
});

export default {
    components: {
        ListSearch,
        SearchDuration,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        push() {
            let { ...query } = this.query || {};

            delete query["page"];

            // 기본값(이번 달)이면 주소를 더럽히지 않는다 — 페이지가 같은 기본값을 다시 채운다.
            if (JSON.stringify(query["searchDateValue"]) == JSON.stringify(initDuration())) delete query["searchDateValue"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
